var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoConnections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 82,
    viewBox: "0 0 151 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Connections",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M99.8518 23.0118L148.693 2M99.8518 23.0118L109.937 33.0527M99.8518 23.0118L103.931 38.3235L109.937 33.0527M148.693 2L111.864 34.9706M148.693 2L115.377 38.3235M148.693 2L127.615 50.8412M111.864 34.9706L115.377 38.3235M111.864 34.9706L109.937 33.0527M115.377 38.3235L117.234 40.2235M127.615 50.8412L117.234 40.2235M127.615 50.8412L111.864 46.147L117.234 40.2235",
    stroke: "#E5E5E5",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M99.3601 46.6396C91.8978 69.3506 5.9048 58.0966 1.3069 81.1922",
    stroke: "#E5E5E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConnections);
export default __webpack_public_path__ + "static/media/NoConnections.1a936b47592e1095a1bc36161703b5e0.svg";
export { ForwardRef as ReactComponent };